import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Cookies from 'js-cookie';
import Header from '../body_root/header';
import demo_photo from './photos/demo_photo.jpg';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import CountryCodeSelect from "../body_root/CountryCodeSelect";
import './list_rent.css';
import { Toast } from '../components_root/ToastContext';
import { MdLocationCity } from "react-icons/md";
import Select_yes_no from "../components_root/select_yes_no";
export const seo = {
    title: "Viabig Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover Viabig's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "viabig services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://viabig.com/services",
    image: "https://viabig.com/assets/logo.png"
};
export default function List_rent() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [water_filter, setWater_filter] = useState(false);
    const [power_inventory, setPower_inventory] = useState(false);
    const [toRent, setToRent] = useState("");
    const [isLoading, setIsLoading] = useState(false);

        const [countrycode, setCountryCode] = useState("+91");
        const [mobilenumber, setMobileNumber] = useState("");

    const [loginisOpen, loginsetIsOpen] = useState(false);
    const [guid, setguid] = useState('');
    useEffect(() => {
        const existingsessiontoken = Cookies.get("sessiontoken");
        if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
            setguid(Cookies.get("guid"));
        } else {
            navigate('/login');
        }
    }, [navigate]);
    //
    const [activeTab, setActiveTab] = useState("rent");
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("page");
        if (tab) setActiveTab(tab.toLowerCase());
    }, []);
    const setTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("page", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", "" + newUrl);
    };

    return (
        <div>
            <Header />
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size p-3">


                    <div className='post-container'>

                        <div className="post_div">
                            <div className="p-3">
                                <div className="text-h1 bold "  >List your property for rent</div>
                                <div className="text-h2"  >We take care of your property</div>
                            </div>
                            <div>
                                <div className="tabs-body">
                                    <div
                                        className={`tabsbutton ${activeTab === "rent" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("rent"); setTabInUrl("rent"); }}
                                    >
                                        <a className="tabs-text text-h2">Rent</a>
                                    </div>
                                    <div
                                        className={`tabsbutton ${activeTab === "property" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("property"); setTabInUrl("property"); }}
                                    >
                                        <a className="tabs-text text-h2">Property</a>
                                    </div>
                                    <div
                                        className={`tabsbutton ${activeTab === "faculties" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("faculties"); setTabInUrl("faculties"); }}
                                    >
                                        <a className="tabs-text text-h2">Faculties</a>
                                    </div>
                                    <div
                                        className={`tabsbutton ${activeTab === "address" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("address"); setTabInUrl("address"); }}
                                    >
                                        <a className="tabs-text text-h2">Address </a>
                                    </div>
                                    <div
                                        className={`tabsbutton ${activeTab === "photos" ? "active" : ""}`}
                                        onClick={() => { setActiveTab("photos"); setTabInUrl("photos"); }}
                                    >
                                        <a className="tabs-text text-h2">Photos </a>
                                    </div>
                                </div>
                                <div className="p-2">
                                    {activeTab === "rent" && (
                                        <div className="ui-items items-back ">
                                            <div className="text-h2 bold items-back-fill p-2">Property information</div>
                                            <table  >

                                                <tr>
                                                    <td className="text-h2 color_light"  >Title</td>
                                                </tr>
                                                <tr>

                                                    <td>
                                                        <input
                                                            className="text-h2 p-2 border w-full"
                                                            type="text"
                                                            maxLength={20}
                                                            placeholder="Enter plot no. e.i,1BHK 2BHK, 3BHK"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light" width={120} >Monthly Rent</td>
                                                </tr>
                                                <tr>

                                                    <td>
                                                        <input
                                                            className="text-h1 p-2 border bold "
                                                            type="number"
                                                            maxLength={10}
                                                            step="1"
                                                            placeholder="0.00"
                                                            onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light" width={120} >Security amount</td>
                                                </tr>
                                                <tr>

                                                    <td>
                                                        <input
                                                            className="text-h1 p-2 border bold "
                                                            type="number"
                                                            maxLength={20}
                                                            step="1"
                                                            placeholder="0.00"
                                                            onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                        />
                                                    </td>
                                                </tr>

                                            </table>
                                            <div className="button-ui fill p-2">Save</div>
                                        </div>
                                    )}
                                    {activeTab === "property" && (
                                        <div className="ui-items items-back ">
                                            <div className="text-h2 bold items-back-fill p-2">Property Information</div>
                                            <table>
                                                <tr>
                                                    <td className="text-h2 color_light" width={120} >Property Type</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <select className=" text-h1 bold p-2 border items-back">
                                                            <option>Apartment</option>
                                                            <option>Flat</option>
                                                            <option>House</option>
                                                            <option>PG</option>
                                                            <option>Hostel</option>
                                                            <option>Commercial</option>
                                                        </select>
                                                    </td>
                                                    <td className="text-h2 color_light" width={90}>To Rent</td>
                                                    <td>
                                                        <select
                                                            className="text-h1 bold p-2 border items-back"
                                                            value={toRent}
                                                            onChange={(e) => setToRent(e.target.value)}
                                                        >

                                                            <option value="family">Family</option>
                                                            <option value="job">Job</option>
                                                            <option value="student">Student</option>
                                                            <option value="boys">Boys</option>
                                                            <option value="girls">Girls</option>
                                                            <option value="anything">Anything</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table  >

                                                <tr>
                                                    <td className="text-h2 color_light"  >Bedroom</td>
                                                </tr>
                                                <tr>

                                                    <td>
                                                        <input
                                                            className="text-h2 p-2 border w-full"
                                                            type="text"
                                                            maxLength={20}
                                                            placeholder="Enter number of room size"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light"  >Drawing Room</td>
                                                </tr>
                                                <tr>

                                                    <td>
                                                        <input
                                                            className="text-h2 p-2 border w-full"
                                                            type="text"
                                                            maxLength={20}
                                                            placeholder="Enter number of Drawing Room size"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light" >Bathroom</td>
                                                </tr>
                                                <tr>

                                                    <td>
                                                        <input
                                                            className="text-h2 p-2 border w-full"
                                                            type="text"
                                                            maxLength={20}
                                                            placeholder="Enter Name"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light">Furniture / Others item , split comma (,)</td>
                                                </tr>
                                                <tr>

                                                    <td>
                                                        <textarea
                                                            className="text-h2 p-2 border w-full"
                                                            type="text"
                                                            maxLength={1000}
                                                            placeholder="Enter item list"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h3 color_light">Split by comma (,)</td>
                                                </tr>
                                            </table>
                                            <div className="button-ui fill p-2">Save</div>
                                        </div>

                                    )}
                                    {activeTab === "faculties" && (
                                        <div className="ui-items items-back ">
                                            <div className="text-h2 bold items-back-fill p-2">Faculties</div>
                                            <table  >

                                                <tr>
                                                    <td className="text-h2 color_light">Full Furnace</td>
                                                    <td>
                                                        <Select_yes_no
                                                            checked={water_filter}
                                                            onChange={(e) => setWater_filter(e.target.checked)}
                                                        />

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light">Water filter</td>
                                                    <td>
                                                        <Select_yes_no
                                                            checked={water_filter}
                                                            onChange={(e) => setWater_filter(e.target.checked)}
                                                        />

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light">Power Inverter</td>
                                                    <td>
                                                        <Select_yes_no
                                                            checked={power_inventory}
                                                            onChange={(e) => setPower_inventory(e.target.checked)}
                                                        />

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light">Freeze</td>
                                                    <td>
                                                        <Select_yes_no
                                                            checked={power_inventory}
                                                            onChange={(e) => setPower_inventory(e.target.checked)}
                                                        />

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light">Air Conditioner (AC)</td>
                                                    <td>
                                                        <Select_yes_no
                                                            checked={power_inventory}
                                                            onChange={(e) => setPower_inventory(e.target.checked)}
                                                        />

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light">Kitchen</td>
                                                    <td>
                                                        <Select_yes_no
                                                            checked={power_inventory}
                                                            onChange={(e) => setPower_inventory(e.target.checked)}
                                                        />

                                                    </td>
                                                </tr>
                                            </table>
                                            <div className="button-ui fill p-2">Save</div>
                                        </div>
                                    )}

                                    {activeTab === "address" && (
                                        <div className="ui-items items-back ">
                                            <div className="text-h2 bold items-back-fill p-2">Property address information</div>

                                            <table  >
                                                <tr>
                                                    <td className="text-h2 color_light"   >Address</td>
                                                </tr>
                                                <tr>

                                                    <td><textarea className="text-h2 bold p-2" type="text" placeholder="Enter Address" /></td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light"  >Floor</td>
                                                </tr>
                                                <tr>

                                                    <td><input className="text-h2 bold p-2" type="text" placeholder="Enter Floor" /></td>
                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light"  >Sector / Phase</td>
                                                </tr>
                                                <tr>


                                                    <td>
                                                        <table>
                                                            <tr>
                                                                <td >
                                                                    <input className="text-h2 bold p-2" type="text" placeholder="Enter Sector" />
                                                                </td>
                                                                <td >
                                                                    <input className="text-h2 bold p-2" type="text" placeholder="Enter Phase" />
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr> <td className="text-h2 color_light"  >City / Zipcode</td></tr>
                                                <tr>


                                                    <td>
                                                        <table>
                                                            <tr>
                                                                <td><input className="text-h2 bold p-2" type="text" placeholder="Enter City" /></td>
                                                                <td >
                                                                    <input className="text-h2 bold p-2" type="text" placeholder="Enter Zipcode" />
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className="text-h2 color_light" >State</td>
                                                </tr>
                                                <tr>

                                                    <td><input className="text-h2 bold p-2" type="text" placeholder="Enter State" /></td>
                                                </tr>
                                                <tr>    <td className="text-h2 color_light">Country</td></tr>
                                                <tr>

                                                    <td><div className="text-h2 bold p-2 border rounded" type="text" placeholder="Enter State">India</div></td>
                                                </tr>
                                            </table>
                                            <div className="button-ui fill p-2">Save</div>
                                        </div>
                                    )}
                                    {activeTab === "photos" && (<div className="ui-items items-back ">
                                        <div className="text-h2 bold items-back-fill p-2">Photos & Video upload 5 files </div>
                                        <div className='post-container'>
                                             <div className="post_div"> post_updates</div>
                                            <div className="post_updates border rounded m-3 p-2">
                                                <table  >
                                                      <tr>
                                                        <td  >
                                                            <div className="file_preview-div " >
                                                            <img className="file_preview" src={demo_photo} 
                                                             alt="Photo" ></img></div>
                                                             </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-h2 color_light"   >Name</td>
                                                    </tr>
                                                    <tr>
                                                        <input className="text-h2  p-2" type="text" maxLength={100} placeholder="Enter name" />
                                                    </tr>
                                                    <tr>
                                                        <td><input className="text-h2 bold p-2" type="file" /></td>

                                                    </tr>
                                                </table>
                                                <div className="button-ui fill p-2">Upload</div>
                                            </div>
                                        </div>
                                    </div>)}

                                </div>
                                <br />
                                <div className="ui-items items-back p-2 ">
                                    <div className="text-h2 bold items-back-fill p-2">Contact information</div>
                                    <table>
                                        <tr>
                                            <td className="text-h2 color_light"  >Owner Name</td>
                                        </tr>
                                        <tr>

                                            <td><input className="text-h2  p-2" type="text" placeholder="Enter Name" /></td>
                                        </tr>
                                        <tr> <td className="text-h2 color_light" >Contact Name</td></tr>
                                        <tr>

                                            <td><input className="text-h2  p-2" type="text" placeholder="Enter Name" /></td>
                                        </tr>
                                        <tr>   <td className="text-h2 color_light">Mobile </td></tr>
                                        <tr>

                                            <td>      <div style={{ display: "flex", alignItems: "center" }} className="border p-1 rounded">
                                                <CountryCodeSelect value={countrycode} onChange={setCountryCode} />
                                                <input
                                                    className="text-h2 bold border-none"
                                                    maxLength={12}
                                                    placeholder="Mobile number *"
                                                    value={mobilenumber}
                                                    onChange={(e) => setMobileNumber(e.target.value)}
                                                />
                                            </div></td>
                                        </tr>
                                    </table>
                                    <div className="button-ui2 fill p-2">Publish</div>
                                </div>
                            </div>
                        </div>
                        <div className="post_updates">
                            <div className="text-h2 m-1">
                                Easily list your property for rent with Viabig Properties and connect with verified tenants across Mohali and Tricity. Get maximum visibility and quick responses.
                            </div>
                            <br />
                            <div className="text-h2 m-1">
                                Showcase your property to thousands of active renters. With our professional listing services, you save time, reduce stress, and find the right tenant faster
                            </div>
                            <br />
                            <div className="text-h2 m-1">
                                From apartments to commercial spaces, Viabig helps you rent out your property with ease. Verified tenant leads, smooth communication, and full support.
                            </div>

                        </div>
                    </div>

                </div>

            </div>

            <Footers />
            <Navbar />
        </div>
    );
}
